import React, { useState } from "react";
import { useLang } from "../context";
import { t } from "../content";
import { http } from "../api";
import { toast } from "sonner";
import { Mail, Instagram, Clock } from "lucide-react";

export default function Contact() {
  const { lang } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/contact", form);
      toast.success(t.contact.sent[lang]);
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Error"); } finally { setLoading(false); }
  };

  const field = (key, type = "text") => (
    <input required type={type} value={form[key]} data-testid={`contact-${key}`}
      onChange={(e) => setForm({ ...form, [key]: e.target.value })} placeholder={t.contact[key][lang]}
      className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-3 outline-none focus:border-[#1A1A1A] transition-colors" />
  );

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 pt-12 grid lg:grid-cols-2 gap-16">
      <div>
        <h1 className="serif text-5xl lg:text-6xl">{t.contact.title[lang]}</h1>
        <p className="mt-6 text-base text-[#404040] leading-relaxed max-w-md">{t.contact.intro[lang]}</p>
        <div className="mt-10 space-y-4 text-sm text-[#404040]">
          <div className="flex items-center gap-3"><Mail size={18} strokeWidth={1.5} /> contactclassonevintage@gmail.com</div>
          <div className="flex items-center gap-3"><Instagram size={18} strokeWidth={1.5} /> @classonevintage</div>
          <div className="flex items-center gap-3"><Clock size={18} strokeWidth={1.5} /> {lang === "fr" ? "Réponse sous 24h, lun–ven" : "Reply within 24h, Mon–Fri"}</div>
        </div>
      </div>
      <form onSubmit={submit} className="space-y-7">
        {field("name")}
        {field("email", "email")}
        <textarea required rows={5} value={form.message} data-testid="contact-message"
          onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder={t.contact.message[lang]}
          className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-3 outline-none focus:border-[#1A1A1A] resize-none" />
        <button type="submit" disabled={loading} data-testid="contact-submit"
          className="bg-[#1A1A1A] text-[#F9F8F6] px-8 py-3.5 text-sm uppercase tracking-widest rounded-sm disabled:opacity-60">
          {loading ? "…" : t.contact.send[lang]}
        </button>
      </form>
    </div>
  );
}
